import { Component } from '@angular/core';
import { AtlasMobileService } from 'src/app/services/ol-map/atlas-mobile.service';
import { OLLegendDefinition } from 'src/app/models/layer';

@Component({
    standalone: false,
    selector: 'app-atlas-mobile-legend',
    templateUrl: './atlas-mobile-legend.component.html',
    styleUrls: ['./atlas-mobile-legend.component.scss'],
})
export class AtlasMobileLegendComponent {
    readonly title = 'Mobile coverage';

    readonly byzoneLegend: OLLegendDefinition = {
        values: [
            { position: 0, label: '0' },
            { position: 1, label: '50' },
            { position: 2, label: '100' },
        ],
    };

    readonly detailedLegend = [
        { label: 'DEEPINDOOR', color: '#0b6e4f' },
        { label: 'INDOOR', color: '#37a66b' },
        { label: 'OUTDOOR', color: '#f2c94c' },
        { label: 'NOSIGNAL', color: '#d95d39' },
    ];

    constructor(private readonly atlasMobileService: AtlasMobileService) {}

    get isDetailedLegend(): boolean {
        return this.atlasMobileService.getStyleName() === 'mobile_detailed';
    }
}
